/**
 * Hero route map — Dublin to Berlin / Paris / Amsterdam.
 * Drawn line + pulsing port rings. Pure SVG + CSS animations.
 */
export default function RouteMap() {
  return (
    <div className="absolute inset-0 pointer-events-none opacity-90" aria-hidden="true" data-testid="hero-route-map">
      <svg
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        className="w-full h-full"
      >
        {/* Animated coral route line */}
        <path
          className="route-draw"
          d="M 180 640 C 420 580, 560 470, 740 420 S 1100 330, 1380 230"
          fill="none"
          stroke="rgba(184,90,72,.55)"
          strokeWidth="1.6"
        />
        {/* Shadow secondary line */}
        <path
          d="M 140 700 C 400 660, 600 560, 800 510 S 1160 420, 1420 330"
          fill="none"
          stroke="rgba(255,255,255,.05)"
          strokeWidth="1"
        />

        {/* DUB — primary port with pulse */}
        <g className="port-in p1">
          <circle cx="380" cy="588" r="4.5" fill="#B85A48" />
          <circle
            className="port-ring"
            cx="380"
            cy="588"
            r="10"
            fill="none"
            stroke="#B85A48"
            strokeWidth="1"
          />
          <text
            x="352"
            y="566"
            style={{
              fontFamily: "'Geist Mono', ui-monospace, monospace",
              fontSize: 10,
              fill: "rgba(255,255,255,.4)",
              letterSpacing: ".25em",
            }}
          >
            DUB
          </text>
        </g>

        {/* BER */}
        <g className="port-in p2">
          <circle cx="880" cy="392" r="3.5" fill="rgba(255,255,255,.5)" />
          <text
            x="858"
            y="370"
            style={{
              fontFamily: "'Geist Mono', ui-monospace, monospace",
              fontSize: 10,
              fill: "rgba(255,255,255,.4)",
              letterSpacing: ".25em",
            }}
          >
            BER
          </text>
        </g>

        {/* PAR */}
        <g className="port-in p3">
          <circle cx="1110" cy="328" r="3.5" fill="rgba(255,255,255,.35)" />
          <text
            x="1088"
            y="306"
            style={{
              fontFamily: "'Geist Mono', ui-monospace, monospace",
              fontSize: 10,
              fill: "rgba(255,255,255,.4)",
              letterSpacing: ".25em",
            }}
          >
            PAR
          </text>
        </g>

        {/* AMS */}
        <g className="port-in p4">
          <circle cx="1310" cy="262" r="3.5" fill="rgba(255,255,255,.25)" />
          <text
            x="1288"
            y="240"
            style={{
              fontFamily: "'Geist Mono', ui-monospace, monospace",
              fontSize: 10,
              fill: "rgba(255,255,255,.4)",
              letterSpacing: ".25em",
            }}
          >
            AMS
          </text>
        </g>
      </svg>
    </div>
  );
}
